/**
 * Procedure Categories and Procedures for DM in Virology students
 * Extracted with strict evidence from official NMC PDF (Page 3, 5, 6: "Psychomotor domain - Virological techniques")
 */
export const VIROLOGY_PROCEDURES = {
  "Viral Culture, Isolation & Microscopic Procedures": [
    "Cell & Tissue Culture for Viral Isolation",
    "Embryonated Hen's Egg Inoculation (Various Routes) & Animal Inoculation",
    "Staining and Light Microscopy for Viral Inclusion Bodies",
    "Transmission Electron Microscopy (TEM) for Viral Particles",
    "Immunofluorescence Assay (IFA - Direct & Indirect) for Viral Antigens",
  ],
  "Viral Serological & Immunodiagnostic Procedures": [
    "Enzyme-Linked Immunosorbent Assay (ELISA) & Enzyme Immunoassay (EIA)",
    "Immunochromatographic (ICT) & Point-of-Care (PoC) Rapid Diagnostic Tests",
    "Immunoblotting & Western Blot Assays for Viral Antibodies/Antigens",
    "Hemagglutination & Haemadsorption Assays",
    "Complement Fixation Test (CFT) & Hemagglutination Inhibition (HAI) Assays",
    "Viral Neutralization Assays",
  ],
  "Molecular Virology, Amplification & Sequencing Procedures": [
    "Viral Nucleic Acid Extraction (DNA & RNA Extraction)",
    "Target Nucleic Acid Amplification (Conventional PCR, Reverse-Transcription PCR & Real-Time Quantitative PCR)",
    "Amplicon Detection Techniques (Agarose Gel Electrophoresis & Molecular Hybridization)",
    "Viral Nucleic Acid Sequencing (Sanger & Next-Generation Sequencing) & Sequence Analysis",
  ],
};

export const VIROLOGY_CATEGORIES = Object.keys(VIROLOGY_PROCEDURES);

export const isDMInVirologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("virology") || d.includes("viral");
};
